

import React, { useState } from "react";


function MSuperAdmin() {

  const permissionsList = [
    
    "Dashboard",
    "Recruitment",
    "Employee",
    "Schedule",
    "Report",
    "Attendance",
    "Timeline",
    "Todo",
    "Settings",
    "UserReport",
    "EmployeeReport",
    "PaySlipReport",
    "LeaveReport",
    "CompanyReport",
  ];

  // 🔍 Employee Search State
  const [employeeSearch, setEmployeeSearch] =
    useState("");

  const [users, setUsers] = useState([
    {
      id: 1,
      name: "Micheal",
      email: "micheal@gmail.com",
      role: "Admin",
      permissionSearch: "",

      permissions: {
       
        Dashboard: true,
        Recruitment: false,
        Employee: true,
        Schedule: false,
        Report: true,
        Attendance: false,
        Timeline: true,
        Todo: true,
        Settings: true,
        UserReport: false,
        EmployeeReport: false,
        PaySlipReport: false,
        LeaveReport: false,
        CompanyReport: false,
      },
    },

    {
      id: 2,
      name: "Ajith",
      email: "ajith@gmail.com",
      role: "Employee",
      permissionSearch: "",

      permissions: {
        Dashboard: true,
        Recruitment: false,
        Employee: false,
        Schedule: true,
        Report: false,
        Attendance: true,
        Timeline: false,
        Todo: true,
        Settings: false,
        UserReport: false,
        EmployeeReport: false,
        PaySlipReport: false,
        LeaveReport: false,
        CompanyReport: false,
      },
    },
    {
      id: 3,
      name: "Shesha",
      email: "shesha@gmail.com",
      role: "Admin",
      permissionSearch: "",

      permissions: {
        Dashboard: true,
        Recruitment: false,
        Employee: true,
        Schedule: false,
        Report: true,
        Attendance: false,
        Timeline: true,
        Todo: true,
        Settings: true,
        UserReport: false,
        EmployeeReport: false,
        PaySlipReport: false,
        LeaveReport: false,
        CompanyReport: false,
      },
    },
    {
      id: 4,
      name: "Vasanth",
      email: "Vasanth@gmail.com",
      role: "HR",
      permissionSearch: "",

      permissions: {
        Dashboard: true,
        Recruitment: false,
        Employee: true,
        Schedule: false,
        Report: true,
        Attendance: false,
        Timeline: true,
        Todo: true,
        Settings: true,
        UserReport: false,
        EmployeeReport: false,
        PaySlipReport: false,
        LeaveReport: false,
        CompanyReport: false,
      },
    },
    {
      id: 5,
      name: "Arun",
      email: "Arun@gmail.com",
      role: "Manager",
      permissionSearch: "",

      permissions: {
        Dashboard: true,
        Recruitment: false,
        Employee: true,
        Schedule: false,
        Report: true,
        Attendance: false,
        Timeline: true,
        Todo: true,
        Settings: true,
        UserReport: false,
        EmployeeReport: false,
        PaySlipReport: false,
        LeaveReport: false,
        CompanyReport: false,
      },
    },
    {
      id: 6,
      name: "Augustin",
      email: "Augustin@gmail.com",
      role: "Team Lead",
      permissionSearch: "",

      permissions: {
        Dashboard: true,
        Recruitment: false,
        Employee: true,
        Schedule: false,
        Report: true,
        Attendance: false,
        Timeline: true,
        Todo: true,
        Settings: true,
        UserReport: false,
        EmployeeReport: false,
        PaySlipReport: false,
        LeaveReport: false,
        CompanyReport: false,
      },
    },
  ]);

  // Toggle Permission
  const togglePermission = (
    userId,
    permission
  ) => {

    const updatedUsers = users.map((user) => {

      if (user.id === userId) {

        return {
          ...user,

          permissions: {
            ...user.permissions,

            [permission]:
              !user.permissions[
                permission
              ],
          },
        };
      }

      return user;
    });

    setUsers(updatedUsers);
  };

  // Permission Search (inside card)
  const handlePermissionSearch = (
    userId,
    value
  ) => {

    const updatedUsers = users.map((user) =>

      user.id === userId
        ? {
            ...user,
            permissionSearch: value,
          }
        : user
    );

    setUsers(updatedUsers);
  };

  // 🔍 Filter Employees (GLOBAL SEARCH)
  const filteredUsers = users.filter(
    (user) =>
      user.name
        .toLowerCase()
        .includes(
          employeeSearch.toLowerCase()
        ) ||
      user.email
        .toLowerCase()
        .includes(
          employeeSearch.toLowerCase()
        )
  );

  return (
    <div
      style={{
        background: "#f4f7fc",
        minHeight: "100vh",
      }}
    >

      

      <div className="container py-5">

        {/* Header */}
        <div className="mb-4">

          <h2 className="fw-bold  text-center ">
            Super Admin Panel
          </h2>

          {/* <p className="text-muted">
            Manage employees and permissions
          </p> */}

        </div>

        {/* 🔍 Employee Search (TOP) */}
        <div className="mb-4">

          <input
            type="text"
            className="form-control form-control-lg shadow-sm"
            placeholder="Search employee by name or email..."
            value={employeeSearch}
            onChange={(e) =>
              setEmployeeSearch(
                e.target.value
              )
            }
          />

        </div>

        {/* Employee Cards */}
        <div className="row">

          {filteredUsers.map((user) => {

            const filteredPermissions =
              permissionsList.filter(
                (permission) =>
                  permission
                    .toLowerCase()
                    .includes(
                      user.permissionSearch.toLowerCase()
                    )
              );

            return (

              <div
                className="col-lg-4 col-md-6 mb-4"
                key={user.id}
              >

                <div
                  className="card border-0 shadow-lg"
                  style={{
                    borderRadius: "20px",
                  }}
                >

                  <div className="card-body">

                    {/* User Info */}
                    <div className="text-center mb-4">

                      <div
                        className="rounded-circle bg-dark text-white d-flex justify-content-center align-items-center mx-auto mb-3"
                        style={{
                          width: "80px",
                          height: "80px",
                          fontSize: "30px",
                          fontWeight: "bold",
                        }}
                      >
                        {user.name.charAt(0)}
                      </div>

                      <h4 className="fw-bold">
                        {user.name}
                      </h4>

                      <p className="text-muted mb-1">
                        {user.email}
                      </p>

                      <span className="badge bg-primary px-3 py-2">
                        {user.role}
                      </span>

                    </div>

                    {/* Permission Search */}
                    <div className="mb-3">

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search permission..."
                        value={
                          user.permissionSearch
                        }
                        onChange={(e) =>
                          handlePermissionSearch(
                            user.id,
                            e.target.value
                          )
                        }
                      />

                    </div>

                    {/* Permissions Scroll */}
                    <div
                      style={{
                        maxHeight: "300px",
                        overflowY: "auto",
                      }}
                    >

                      {filteredPermissions.map(
                        (permission) => (

                          <div
                            key={permission}
                            className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                          >

                            <span>
                              {permission}
                            </span>

                            <div className="form-check form-switch">

                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={
                                  user.permissions[
                                    permission
                                  ]
                                }
                                onChange={() =>
                                  togglePermission(
                                    user.id,
                                    permission
                                  )
                                }
                              />

                            </div>

                          </div>
                        )
                      )}

                    </div>

                  </div>

                </div>

              </div>
            );
          })}

        </div>

      </div>

    </div>
  );
}

export default MSuperAdmin;